<template>
  <g-master name="employee_cargo"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            @params="paramsTable"
            modalWidth="90%"
  >
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Cargo')"
                      :formItemConfig="fiOptions"
                      endpoint="jobs"
                      :decorator="['id_job', { rules: [{ required: false, message: 'Valor requerido'}] }]">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha Inicio Vigencia')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha Fin Vigencia')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'emp_jobs',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Cargo', dataIndex: 'job_name', sorter: true},
              {title: 'Fecha inicio vigencia', dataIndex: 'init_date_mask', sorter: true},
              {title: 'Fecha fin vigencia', dataIndex: 'end_date_mask', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'end_date'},
            {name: 'id_job'},
            {name: 'init_date'}
          ]
        },
        paramsT: {},
        endpointExcel: 'emp_jobs_/downloadExcel',
        fileNameExcel: 'CargoEmpleado'
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.parentData}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeCargo.vue